import { computed } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import routerServices from './router.service';

import InsightRouteRoot from '@insight/index';
import ExperienceRouteRoot from '@experience/index';
import LandingPageRoot from '@landingPage/index';

const Login = () => import('@master/views/login/Login.vue');
const ProfileList = () => import('@master/views/project/ProjectList.vue');

const Main = () => import('@master/views/main/Main.vue');

const SuperLogin = () => import('@master/views/login/SuperLogin.vue');
const ForgetPass = () => import('@master/views/login/ForgetPass.vue');
const ForgetPasswordReset = () => import('@master/views/login/ForgetPasswordReset.vue');

const ProductList = () => import('@master/views/product/ProductList.vue');
const Home = () => import('@master/views/home/Home.vue');
const CreateProject = () => import('@master/views/project/ProjectCreate.vue');
const Setup = () => import('@master/views/setup/Setup.vue');
const SetupSuccess = () => import('@master/views/setup/SetupSuccess.vue');

const Password = () => import('@master/views/account/Password.vue');
const AccountMain = () => import('@master/views/account/AccountMain.vue');
const AccountInfo = () => import('@master/views/account/AccountInfo.vue');
const AccountActive = () => import('@master/views/account/AccountActive.vue');
const UnionAccountActive = () => import('@master/views/account/UnionAccountActive.vue');

const Signup = () => import('@master/views/signup/Signup.vue');
const ThanksForSignup = () => import('@master/views/signup/ThanksForSignup.vue');

const PlanMain = () => import('@master/views/plan/PlanMain.vue');
const InsightPlan = () => import('@master/views/plan/InsightPlan.vue');
const ExperiencePlan = () => import('@master/views/plan/ExperiencePlan.vue');

const PlanUsage = () => import('@pages/master/views/new-plan/Unsubscribe/PlanUsage.vue');
const PlanMainNew = () => import('@master/views/new-plan/PlanMain.vue');
const Changeplan = () => import('@master/views/new-plan/Changeplan.vue');
const PaySuccess = () => import('@master/views/new-plan/PaySuccess.vue');
const Unsubscribe = () => import('@pages/master/views/new-plan/Unsubscribe/Unsubscribe.vue');
// 新用户设置页面
const Member = () => import('@pages/master/views/setting/member/Member.vue');
const PaymentMethod = () => import('@master/views/new-plan/PaymentMethod.vue');
const BillingHistory = () => import('@master/views/new-plan/BillingHistory.vue');
const BillAccountConf = () => import('@master/views/new-plan/BillAccountConf.vue');

const LandingPagePreview = () => import('@landingPage/views/preview/LandingPagePreview.vue');

const Gallery = () => import('@master/views/product/Gallery.vue');
const Auth = () => import('@master/views/product/Auth.vue');

const routes: any = [
    {
        path: '/signup',
        name: 'Signup',
        component: Signup,
        beforeEnter: routerServices.beforeEnterSignup,
        meta: {
            titleI18n: 'router_title.signup.page_title',
            isWhiteList: true
        }
    },
    {
        path: '/signup/thanks',
        name: 'ThanksForSignup',
        component: ThanksForSignup,
        meta: {
            titleI18n: 'router_title.signup.page_title',
            isWhiteList: true,
            hideHeader: true
        }
    },
    {
        path: '/active/account/',
        name: 'AccountActive',
        component: AccountActive,
        beforeEnter: routerServices.beforeEnterLogout,
        meta: {
            titleI18n: 'router_title.account.email_sent_page_title',
            isWhiteList: true,
            hideHeader: true
        }
    },
    {
        path: '/active/union_account',
        name: 'UnionAccountActive',
        component: UnionAccountActive,
        meta: {
            titleI18n: 'router_title.account.email_sent_page_title',
            isWhiteList: true,
            hideHeader: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        beforeEnter: routerServices.beforeEnterCheckLoggedIn,
        meta: {
            titleI18n: 'router_title.login_title',
            isWhiteList: true,
            hideHeader: true
        }
    },
    {
        path: '/superLogin',
        name: 'SuperLogin',
        component: SuperLogin,
        beforeEnter: routerServices.beforeEnterLogout,
        meta: {
            titleI18n: 'login.page_title',
            isWhiteList: true
        }
    },
    {
        path: '/gallery',
        name: 'Gallery',
        component: Gallery,
        meta: {
            titleI18n: 'product.template_gallery_npwrap',
            isWhiteList: true
        },
        children: [
            {
                name: 'GalleryView',
                path: ':templateId',
                component: Gallery,
                meta: {
                    titleI18n: 'product.template_gallery_npwrap',
                    isWhiteList: true
                }
            }
        ]
    },
    {
        path: '/auth',
        name: 'Auth',
        component: Auth,
        meta: {
            titleI18n: 'login.page_title',
            isWhiteList: true
        }
    },
    {
        path: '/forget',
        name: 'ForgetPass',
        component: ForgetPass,
        meta: {
            titleI18n: 'router_title.forget_page_title',
            hideHeader: true,
            isWhiteList: true
        }
    },
    {
        path: '/forget_reset',
        name: 'ForgetPasswordReset',
        component: ForgetPasswordReset,
        meta: {
            titleI18n: 'router_title.forget_reset_page_title',
            hideHeader: true,
            isWhiteList: true
        }
    },
    {
        path: '/create_project',
        name: 'CreateProject',
        component: CreateProject,
        meta: {
            titleI18n: 'create_profile.title',
            hideHeader: true
        }
    },
    {
        path: '/select_project',
        name: 'ProfileList',
        component: ProfileList,
        beforeEnter: routerServices.beforeEnterProfileList,
        meta: {
            titleI18n: 'router_title.select_project_title'
        }
    },
    {
        path: '/account',
        name: 'Account',
        component: AccountMain,
        children: [
            {
                name: 'AccountInfo',
                path: 'info',
                component: AccountInfo,
                meta: {
                    titleI18n: 'router_title.account_info_title'
                }
            },
            {
                name: 'Password',
                path: 'password',
                component: Password,
                meta: {
                    titleI18n: 'router_title.account_password_title'
                }
            }
        ]
    },
    {
        name: 'LandingPagePreview',
        path: '/:sid/landing_page/:pageId/preview/:versionId',
        component: LandingPagePreview,
        meta: {
            isWhiteList: true,
            titleI18n: 'router_title.landing_page.page_preview'
        }
    },
    {
        path: '/:sid',
        name: 'AppMain',
        component: Main,
        beforeEnter: routerServices.beforeEnterMain,
        redirect: { name: 'ProductList' },
        children: [
            {
                path: 'product',
                name: 'ProductList',
                component: ProductList,
                beforeEnter: routerServices.beforeEnterProduct
            },
            {
                path: 'home',
                name: 'Home',
                component: Home,
                beforeEnter: routerServices.beforeEnterHome
            },
            {
                path: 'gallery',
                name: 'ProductGallery',
                component: Gallery,
                meta: {
                    titleI18n: 'product.template_gallery_npwrap',
                    isWhiteList: true
                },
                children: [
                    {
                        name: 'ProductGalleryView',
                        path: ':templateId',
                        component: Gallery,
                        meta: {
                            titleI18n: 'product.template_gallery_npwrap',
                            isWhiteList: true
                        }
                    }
                ]
            },
            {
                path: 'setup',
                name: 'Setup',
                component: Setup,
                meta: {
                    titleI18n: 'router_title.setup_page_title',
                    hideHeader: true
                }
            },
            {
                path: 'setup_success',
                name: 'SetupSuccess',
                component: SetupSuccess,
                meta: {
                    titleI18n: 'router_title.setup_page_title',
                    hideHeader: true
                }
            },
            {
                path: 'changeplan',
                name: 'Changeplan',
                component: Changeplan,
                meta: {
                    titleI18n: 'router_title.plan_new.change_plan',
                    hideHeader: true
                }
            },
            {
                path: 'paysuccess',
                name: 'PaySuccess',
                component: PaySuccess,
                meta: {
                    titleI18n: 'router_title.plan_new.change_plan_success',
                    hideHeader: true
                }
            },
            {
                path: 'plan_new',
                name: 'PlanNew',
                component: PlanMainNew,
                meta: {
                    hideHeader: true
                },
                redirect: () => {
                    return {
                        name: 'PlanUsage'
                    };
                },
                children: [
                    {
                        name: 'PlanUsage',
                        path: 'plan_usage',
                        component: PlanUsage,
                        meta: {
                            titleI18n: 'router_title.plan_new.plan_usage'
                        }
                    },
                    {
                        name: 'PaymentMethod',
                        path: 'payment_method',
                        component: PaymentMethod,
                        meta: {
                            titleI18n: 'router_title.insight_plan_title'
                        }
                    },
                    {
                        name: 'BillAccountConf',
                        path: 'bill_account_conf',
                        component: BillAccountConf,
                        meta: {
                            titleI18n: 'router_title.insight_plan_title'
                        }
                    },
                    {
                        name: 'BillingHistory',
                        path: 'billing_history',
                        component: BillingHistory,
                        meta: {
                            titleI18n: 'router_title.plan_new.billing_history'
                        }
                    }
                ]
            },
            {
                name: 'Unsubscribe',
                path: 'Unsubscribe',
                component: Unsubscribe,
                meta: {
                    hideHeader: true,
                    titleI18n: 'router_title.plan_new.unsubscribe'
                }
            },
            {
                path: 'member',
                name: 'Member',
                component: Member,
                meta: {
                    hideHeader: true,
                    titleI18n: 'router_title.member_manage.title'
                }
            },
            ...InsightRouteRoot.router,
            ...ExperienceRouteRoot.router,
            ...LandingPageRoot.router
        ]
    },
    {
        path: '/plan',
        name: 'Plan',
        component: PlanMain,
        beforeEnter: routerServices.beforeEnterInsightPlan,
        children: [
            {
                name: 'InsightPlan',
                path: 'insight/:path*',
                component: InsightPlan,
                meta: {
                    titleI18n: 'router_title.insight_plan_title'
                }
            },
            {
                name: 'ExperiencePlan',
                path: 'experience',
                component: ExperiencePlan,
                meta: {
                    titleI18n: 'router_title.experience_plan_title'
                }
            }
        ]
    },

    {
        path: '/',
        name: 'Root',
        redirect: () => {
            return {
                name: 'ProfileList'
            };
        }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: () => {
            return {
                name: 'ProfileList'
            };
        }
    }
];

const baseUrl = (import.meta.env.VITE_BASE_URL || '/') as string;
const router = createRouter({
    history: createWebHistory(baseUrl),
    routes,
    scrollBehavior(to, from, savedPosition) {
        const routeParamsPosition = to.params.savedPosition;
        const _savedPosition: any =
            savedPosition ||
            (routeParamsPosition &&
                typeof routeParamsPosition === 'string' &&
                JSON.parse(routeParamsPosition));
        if (_savedPosition) {
            return _savedPosition;
        } else {
            return { top: 0 };
        }
    }
});

export const route = computed(() => router.currentRoute.value);

export function resetRouter() {
    router.addRoute(routes);
}

router.beforeEach(routerServices.beforeChange);
router.afterEach(routerServices.afterChange);
export default router;
